export default __webpack_public_path__ + "static/assets/info.483693c6.png";